import { useTranslation } from 'react-i18next';

export default function LanguageSwitcher() {
  const { t, i18n } = useTranslation();
  const isES = i18n.language?.startsWith('es');

  return (
    <button
      onClick={() => i18n.changeLanguage(isES ? 'en' : 'es')}
      className="flex items-center gap-1 px-2 py-1 text-xs font-semibold rounded border border-current opacity-80 hover:opacity-100 transition-opacity"
      title={isES ? t('lang.switchToEn') : t('lang.switchToEs')}
    >
      {isES ? 'EN' : 'ES'}
    </button>
  );
}
